import { BASE_URL } from '../../api';
import axios from 'axios';
import React, { useState } from 'react';
import PasswordChecklist from 'react-password-checklist';
import { Navigate, useLocation } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { I18n, Translate } from '@utils/i18n';
import './styles.scss';

const CompleteSignup: React.FC<React.PropsWithChildren> = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [redirect, setRedirect] = useState<boolean>(false);
  const firstNameRef = React.useRef<HTMLInputElement>(null);
  const lastNameRef = React.useRef<HTMLInputElement>(null);
  const [passwordInput, setPasswordInput] = React.useState<string>('');
  const [confirmPasswordInput, setConfirmPasswordInput] =
    React.useState<string>('');
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const location = useLocation();

  const handleConfirm = (event: React.FormEvent) => {
    setLoading(true);
    event.preventDefault();
    if (firstNameRef.current !== null) {
      const firstName = firstNameRef.current.value;
      const lastName = lastNameRef.current?.value;
      const password = passwordInput;
      if (isPasswordValid) {
        const query = new URLSearchParams(location.search);
        const data = query.get('email');
        const [email, tempPass] = data!.split('/');
        axios
          .post(`${BASE_URL}/identity/invite/confirm`, {
            firstName,
            lastName,
            email,
            password: tempPass,
            newPassword: password
          })
          .then((res) => res.data)
          .then(() => {
            toast.success(I18n.t('you_are_signed'), {
              autoClose: 2000,
              onClose: () => {
                setRedirect(true);
              }
            });
          })
          .catch((e) => {
            toast.error(`Error ${e.message}`);
            setLoading(false);
          });
      } else {
        toast.error(I18n.t('password_dont_match_policy'));
        setLoading(false);
      }
    } else {
      toast.error(I18n.t('fields_cant_be_empty'));
      setLoading(false);
    }
  };

  return (
    <div className="py-7 px-5">
      <div className="card-title mb-4">
        <strong>
          <Translate value="complete_profile" />
        </strong>
      </div>
      <form id="login-form" className="login-form-1" onSubmit={handleConfirm}>
        <div>
          <label htmlFor="lg_confirmCode" className="input__label">
            <Translate value="first_name" />
          </label>
          <div className="input-group py-1">
            <input
              type="text"
              className="form-control"
              id="lg_firstName"
              name="firstName"
              placeholder={I18n.t('first_name')}
              required
              ref={firstNameRef}
            />
          </div>
        </div>
        <div className="mt-2">
          <label htmlFor="lg_confirmCode" className="input__label">
            <Translate value="last_name" />
          </label>
          <div className="input-group py-1">
            <input
              type="text"
              className="form-control"
              id="lg_lastName"
              name="lastName"
              placeholder={I18n.t('last_name')}
              required
              ref={lastNameRef}
            />
          </div>
        </div>
        <div className="mt-2">
          <div className="mtF mb-1 info__text">
            <Translate value="set_password_for_new_account" />
          </div>
          <label htmlFor="lg_password" className="input__label">
            <Translate value="new_password" />
          </label>
          <div className="input-group py-1">
            <input
              type="password"
              className="form-control"
              id="lg_password"
              name="password"
              placeholder={I18n.t('new_password')}
              required
              onChange={(e) => setPasswordInput(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-2 mb-2">
          <label htmlFor="lg_confirm_password" className="input__label">
            <Translate value="confirm_password" />
          </label>
          <div className="input-group py-1">
            <input
              type="password"
              className="form-control"
              id="lg_confirm_password"
              name="confirm_password"
              placeholder={I18n.t('confirm_password')}
              required
              onChange={(e) => setConfirmPasswordInput(e.target.value)}
            />
          </div>
        </div>
        {passwordInput.length > 0 && (
          <div
            className="password-checklist-container"
            style={
              !isPasswordValid
                ? { borderColor: '#ff003396' }
                : { borderColor: '#4bd1a0b2' }
            }
          >
            <PasswordChecklist
              rules={['minLength', 'number', 'match']}
              minLength={8}
              value={passwordInput}
              valueAgain={confirmPasswordInput}
              onChange={(isValid) => setIsPasswordValid(isValid)}
              messages={{
                minLength: I18n.t('password_check_minLength', { minLength: 8 }),
                number: I18n.t('password_check_number'),
                match: I18n.t('password_check_match')
              }}
            />
          </div>
        )}
        <div className="submit-button-container text-center mt-4">
          <button type="submit" className="btn mt-2 submit-button px-4">
            {loading ? (
              <ClipLoader size={20} loading color={'#fff'} />
            ) : (
              I18n.t('confirm_signup')
            )}
          </button>
        </div>
      </form>
      {redirect && <Navigate to={{ pathname: '/login' }} replace />}
    </div>
  );
};

export default CompleteSignup;
